import { render, staticRenderFns } from "./SearchStudentTransfer.vue?vue&type=template&id=37e35602&scoped=true&"
import script from "./SearchStudentTransfer.vue?vue&type=script&lang=js&"
export * from "./SearchStudentTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e35602",
  null
  
)

export default component.exports